import { TemplateContentEnum } from "@/model/data/enums/TemplateContentEnum";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetTemplatesResData } from "./GetTemplatesResData";
import { StocksProfileEnum } from "@/model/data/enums/StocksProfileEnum";

const ENDPOINT = "/security/templates";

export class GetTemplatesCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    payload: GetTemplatesReqData;

    constructor(payload: GetTemplatesReqData) {
        super();
        this.payload = payload;
    }

    public async execute(): Promise<GetTemplatesResData> {
        let res = await this.executeCommand(this.payload);
        return new GetTemplatesResData(res);
    }
}

export class GetTemplatesReqData {
    templateName: string = null;
    templateContent: TemplateContentEnum = null;
    roolsProfile: StocksProfileEnum = null;
}
